import React from "react";
import "../../styles/components/loader.scss";

function Loader({isLoading = false, isFixed = true}) {
    return (
        <>
            <div className={`loader ${isFixed ? 'fixed' : 'absolute'} ${!isLoading ? 'd-none' : ''}`}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </>
    );
}
export default Loader;